<template>
  <nav class="navigation">
    <ul>
      <li v-for="(item, index) in items" :key="index" class="navigation-item">
        <a
          :href="route(item.route)"
          :title="item.name"
          :class="{
            'is-active': isActive(item.route)
          }"
        >
          {{ item.name }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "AppNavigation",
  props: {
    items: {
      type: Array,
      required: true,
      validator(value) {
        return (
          value.filter(i => {
            return i.hasOwnProperty("name") && i.hasOwnProperty("route");
          }).length === value.length
        );
      }
    }
  },
  methods: {
    isActive(route) {
      const routeURL = this.route(route);
      const regex = new RegExp(
        "^(" + routeURL.template + ")(?:[/a-z]+)?",
        "gi"
      );
      if (routeURL.name === "home")
        return window.location.href === routeURL.template;
      return regex.test(window.location.href);
    }
  }
};
</script>

<style>
.navigation ul {
  @apply list-reset mr-2 flex;
}

.navigation-item {
  @apply mr-2;
}

.navigation-item a {
  @apply block leading-loose text-black no-underline font-semibold px-4;
  transition: all 0.2s ease-in-out;
}

.navigation-item a:hover {
  @apply text-primary-500;
}

.navigation-item a.is-active {
  @apply text-primary-800;
}
</style>
